import React from 'react';
import PropTypes from 'prop-types';
// @mui
import Stack from '@mui/material/Stack';
//
import NavList from './nav-list';

// ----------------------------------------------------------------------

export default function NavDesktop({ offsetTop, data, onNavHover, commonData }) {
  const [openMenu, setOpenMenu] = React.useState(null);

  React.useEffect(() => {
    if (!openMenu) return;

    const handleScroll = () => {
      if (window.scrollY > 0) {
        setOpenMenu(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
  }, [openMenu]);

  const handleMenuToggle = (title, isOpen) => {
    setOpenMenu(isOpen ? title : null);
    onNavHover?.(isOpen);
  };

  return (
    <Stack component="nav" direction="row" spacing={5} sx={{ mr: 2.5, height: 1 }}>
      {data.map((link) => (
        <NavList
          key={link.title}
          item={link}
          offsetTop={offsetTop}
          onNavHover={onNavHover}
          isAnyMenuOpen={!!openMenu}
          onMenuToggle={handleMenuToggle}
          commonData={commonData}
        />
      ))}
    </Stack>
  );
}

NavDesktop.propTypes = {
  data: PropTypes.array,
  offsetTop: PropTypes.bool,
  onNavHover: PropTypes.func,
  commonData: PropTypes.object,
};
